import React, { useCallback, useEffect, useRef, useState } from "react";
import { Icon } from "@components/Icon/Icon";
import logoIcon from "@svg-icons/logo.component.svg";
import styles from "./styles.module.scss";
import { Container } from "@components/Container/Container";
import {
  useSharedNavToggleState
} from "@components/Navigation/Navigation";
import classnames from "classnames";
import { Link } from "@components/Link/Link";
import { PrimitiveProps } from "@helpers/interfaces/primitive";
import throttle from "lodash/throttle";

export interface HeaderProps extends PrimitiveProps {
  useTransparentBackground: boolean;
}

const MinimalHeader: React.FC<HeaderProps> = props => {
  const { isActive } = useSharedNavToggleState();
  const headerRef = useRef<HTMLElement>(null);

  const [prevScrollPos, setPrevScrollPos] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);

  const handleScroll = useCallback(() => {
    // find current scroll position
    const currentScrollPos = window.pageYOffset;
    const headerHeight = headerRef.current?.offsetHeight ?? 0;
    // set state based on location info (explained in more detail below)
    setVisible(
      currentScrollPos > prevScrollPos && currentScrollPos > headerHeight
    );

    // set state to new scroll position
    setPrevScrollPos(currentScrollPos);
  }, [prevScrollPos]);

  useEffect(() => {
    const throttleCallback = throttle(handleScroll, 500);
    window.addEventListener("scroll", throttleCallback);

    return (): void => window.removeEventListener("scroll", throttleCallback);
  }, [prevScrollPos, visible, handleScroll]);
  return (
    <header
      ref={headerRef}
      className={classnames(
        styles.header,
        props.useTransparentBackground && styles.headerTransparent,
        (!visible || isActive) && styles.headerVisible,
        isActive && styles.navOpen
      )}
    >
      <Container className={styles.headerContainer}>
        <Link
          href="/"
          className={classnames(styles.logo, isActive && styles.logoNavActive)}
          title="Sikkertrafik"
        >
          <Icon svg={logoIcon} title="Logo" />
        </Link>
      </Container>
    </header>
  );
};

export { MinimalHeader };
